const ARRAY: any = (Array as any)

export function asArray(arr: any): Array<any> {
    if (arr != undefined) {
        if (ARRAY.from != undefined) return ARRAY.from(arr)
        else {
            const newArr: Array<any> = []

            for (let i = 0; i < arr.length; i ++) {
                newArr.push(arr[i])
            }

            return newArr
        }
    } else {
        console.debug('Array was undefined.')
        return []
    }
}